import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import FieldNames from "../defaults/FieldNames.json";
import Request from "./request";
import GeneralService from "./GeneralService";
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from "../utils/ReduxHelper";

const BudgetService = {
  // Budget GET queries
  getSelectedBudget: function (
    fiscalYear,
    department,
    agency,
    region,
    unit,
    subunit,
    tribeFullName,
    entityType
  ) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let baseWhereClause = "";
      let departmentExists =
        department && department[FieldNames.budgetFields.department];
      let agencyExists = agency && agency[FieldNames.budgetFields.agency];
      let regionExists = region && region[FieldNames.budgetFields.region];
      let unitExists = unit && unit[FieldNames.budgetFields.unit];
      let subUnitExists = subunit && subunit[FieldNames.budgetFields.subUnit];
      let tribeExists =
        tribeFullName &&
        tribeFullName[FieldNames.budgetFields.constructedTribeFullName];
      let year = Number(fiscalYear.FiscalYear);
  
      baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.budgetFields.department]
            }')`
          : `(Department = '')`);
      baseWhereClause =
        baseWhereClause +
        (agencyExists
          ? ` AND (Agency = '${agency[FieldNames.budgetFields.agency]}')`
          : ` AND (Agency = '')`);
      baseWhereClause =
        baseWhereClause +
        (regionExists
          ? ` AND (Region = '${region[FieldNames.budgetFields.region]}')`
          : ` AND (Region = '')`);
      baseWhereClause =
        baseWhereClause +
        (unitExists
          ? ` AND (Unit = '${unit[FieldNames.budgetFields.unit]}')`
          : ` AND (Unit = '')`);
      baseWhereClause =
        baseWhereClause +
        (subUnitExists
          ? ` AND (SubUnit = '${subunit[FieldNames.budgetFields.subUnit]}')`
          : ` AND (SubUnit = '')`);
      baseWhereClause =
        baseWhereClause +
        (tribeExists
          ? ` AND (Tribe = '${
              tribeFullName[FieldNames.budgetFields.constructedTribeFullName]
        }')`
          : ` AND (Tribe = '')`);
      baseWhereClause =
        baseWhereClause +
        (entityType
          ? ` AND (EntityType = '${
              entityType
        }')`
          : ``);
  
      let finalClause = "(" + baseWhereClause + ` AND (FiscalYear = ${year}))`;

      const queryObject = new Query({
        where: finalClause,
        outFields: "*",
        returnDistinctValues: true,
        orderByFields: "OBJECTID",
        returnGeometry: false,
      });

      return GeneralService.queryCallDirect(
          rootServiceUrl + "/" + config.budget[config.env].layerId,
          queryObject
        )
        .then((results) => {
          let items = [];
          if (results && results.features && results.features.length > 0) {
            let initialSet = [];
            initialSet = results.features.map((eaItem) => eaItem.attributes);
            if (initialSet && initialSet.length > 0) {
              items = initialSet.map((item) => {
                let budgetObj = {
                  OBJECTID: item.OBJECTID,
                  RegularBudget: item[FieldNames.budgetFields.regularBudget],
                  BILBudget: item[FieldNames.budgetFields.bilBudget],
                  DisasterReliefBudget:
                    item[FieldNames.budgetFields.disasterReliefBudget],
                };

                return budgetObj;
              });
            }
          }
          return items;
        });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllBudgetEntries: function (
    fiscalYear,
    department,
    agency,
    region,
    unit,
    subunit,
    tribeFullName,
    entityType
  ) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let baseWhereClause = "";
      let departmentExists =
        department && department[FieldNames.budgetFields.department];
      let agencyExists = agency && agency[FieldNames.budgetFields.agency];
      let regionExists = region && region[FieldNames.budgetFields.region];
      let unitExists = unit && unit[FieldNames.budgetFields.unit];
      let subUnitExists = subunit && subunit[FieldNames.budgetFields.subUnit];
      let tribeExists =
        tribeFullName &&
        tribeFullName[FieldNames.budgetFields.constructedTribeFullName];
      let year = Number(fiscalYear.FiscalYear);
      let entityTypeSelection = entityType ? entityType : FieldNames.datasets.fuels;
  
      if(!departmentExists)
      {
        // We are looking at possible department values, so don't filter department
        baseWhereClause = `(Agency = '')`;
        baseWhereClause = baseWhereClause + ` AND (Region = '')`;
        baseWhereClause = baseWhereClause + ` AND (Unit = '')`;
        baseWhereClause = baseWhereClause + ` AND (SubUnit = '')`;
        baseWhereClause = baseWhereClause + ` AND (Tribe = '')`;
      }
      else if (departmentExists && !agencyExists) {
        // Filter lower level entries out
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.budgetFields.department]
            }')`
          : `(Department = '')`);
  
        // We are looking at possible agency values, so don't filter agency
        baseWhereClause = baseWhereClause + ` AND (Region = '')`;
        baseWhereClause = baseWhereClause + ` AND (Unit = '')`;
        baseWhereClause = baseWhereClause + ` AND (SubUnit = '')`;
        baseWhereClause = baseWhereClause + ` AND (Tribe = '')`;
      } else if (departmentExists && agencyExists && !regionExists) {
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.budgetFields.department]
            }')`
          : `(Department = '')`);

        baseWhereClause =
        baseWhereClause +
        (agencyExists
           ? ` AND (Agency = '${agency[FieldNames.budgetFields.agency]}')`
           : ` AND (Agency = '')`);

        // We are looking at possible region values, so don't filter region
        baseWhereClause = baseWhereClause + ` AND (Unit = '')`;
        baseWhereClause = baseWhereClause + ` AND (SubUnit  = '')`;
        baseWhereClause = baseWhereClause + ` AND (Tribe  = '')`;
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        !unitExists
      ) {
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.budgetFields.department]
            }')`
          : `(Department = '')`);
        baseWhereClause =
          baseWhereClause +
          (agencyExists
            ? ` AND (Agency = '${agency[FieldNames.budgetFields.agency]}')`
            : ` AND (Agency = '')`);
        baseWhereClause =
          baseWhereClause +
          (regionExists
            ? ` AND (Region = '${region[FieldNames.budgetFields.region]}')`
            : ` AND (Region = '')`);

        // We are looking at possible unit values, so don't filter unit
        // Don't filter out subunit/tribal data as they can be set from region level
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        !subUnitExists &&
        !tribeExists
      ) {
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.budgetFields.department]
            }')`
          : `(Department = '')`);
        baseWhereClause =
          baseWhereClause +
          (agencyExists
            ? ` AND (Agency = '${agency[FieldNames.budgetFields.agency]}')`
            : ` AND (Agency = '')`);
        baseWhereClause =
          baseWhereClause +
          (regionExists
            ? ` AND (Region = '${region[FieldNames.budgetFields.region]}')`
            : ` AND (Region = '')`);
        baseWhereClause =
          baseWhereClause +
          (unitExists
            ? ` AND (Unit = '${unit[FieldNames.budgetFields.unit]}')`
            : ` AND (Unit = '')`);
      } else {
        // No grid values when looking at SubUnit/Tribal level
        return new Promise((resolve) => {
          resolve([]);
        });
      }
  
      baseWhereClause = baseWhereClause + ` AND (EntityType = '${entityTypeSelection}')`
      let finalClause = "(" + baseWhereClause + ` AND (FiscalYear = ${year}))`;

      const queryObject = new Query({
        where: finalClause,
        outFields: "*",
        returnDistinctValues: true,
        orderByFields: "OBJECTID",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(
          rootServiceUrl + "/" + config.budget[config.env].layerId,
          queryObject
        )
        .then((results) => {
          let items = [];
          if (results && results.features && results.features.length > 0) {
            let initialSet = [];
            initialSet = results.features.map((eaItem) => eaItem.attributes);
            if (initialSet && initialSet.length > 0) {
              items = initialSet.map((item) => {
                let name = !departmentExists
                  ? item[FieldNames.budgetFields.department]
                  : !agencyExists
                  ? item[FieldNames.budgetFields.agency]
                  : !regionExists
                  ? item[FieldNames.budgetFields.region]
                  : item[FieldNames.budgetFields.unit];
                let row = {
                  ID: item[FieldNames.featureFields.id],
                  OBJECTID: item[FieldNames.featureFields.objectID],
                  Name: name,
                  Department: item[FieldNames.budgetFields.department],
                  Agency: item[FieldNames.budgetFields.agency],
                  Region: item[FieldNames.budgetFields.region],
                  Unit: item[FieldNames.budgetFields.unit],
                  SubUnit: item[FieldNames.budgetFields.subUnit],
                  Tribe: item[FieldNames.budgetFields.tribe],
                  RegularBudget: item[FieldNames.budgetFields.regularBudget],
                  BILBudget: item[FieldNames.budgetFields.bilBudget],
                  DisasterReliefBudget:
                    item[FieldNames.budgetFields.disasterReliefBudget],
                  TotalBudget:
                    item[FieldNames.budgetFields.regularBudget] +
                    item[FieldNames.budgetFields.bilBudget] +
                    item[FieldNames.budgetFields.disasterReliefBudget],
                  CreatedBy: item[FieldNames.featureFields.createdBy],
                  CreatedOnDate:
                    item[FieldNames.featureFields.createdOnDate],
                  LastModifiedBy:
                    item[FieldNames.featureFields.lastModifiedBy],
                  LastModifiedDate:
                    item[FieldNames.featureFields.lastModifiedDate],
                  IsArchived: FieldNames.yesNo.no,
                };

                return row;
              });
            }
          }
          return items;
        });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },

  //
  // Budget POST queries
  //

  addBudgetEntry: function (budgetObj) {
    try
    {
      if (!budgetObj) {
        throw Error("Missing Budget Object");
      }
  
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();

      const newBudgetEntry = {
        attributes: budgetObj,
      };

      return new Promise((resolve, reject) => {
        new Request()
          .makeRequest({
            url:
              rootServiceUrl +
              "/" +
              config.budget[config.env].layerId +
              "/addFeatures",
            method: "post",
            data: {
              f: "json",
              token: nifcToken,
              features: JSON.stringify([newBudgetEntry]),
            },
          })
          .then(
            (resp) => {
              resolve(resp);
            },
            (error) => {
              reject(error);
            }
          );
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  updateBudgetEntry: function (budgetInfo) {
    try
    {
      let budgetObj = {
        attributes: budgetInfo,
      };

      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();

      return new Promise((resolve, reject) => {
        new Request()
          .makeRequest({
            url:
              rootServiceUrl +
              "/" +
              config.budget[config.env].layerId +
              "/updateFeatures",
            method: "post",
            data: {
              f: "json",
              token: nifcToken,
              features: JSON.stringify([budgetObj]),
            },
          })
          .then(
            (resp) => {
              resolve(resp);
            },
            (error) => {
              reject(error);
            }
          );
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  addMultipleBudgets: async function (
    budgetsForAdding
  ) {
    try
    {
      let allFinalResults = [];
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();

      let featureUrl = `${rootServiceUrl}/${
        config.budget[config.env].layerId
      }/addFeatures`;

      let adjustedBudgets = [];
      budgetsForAdding.forEach((budget) => {
        const newFeature = {
          attributes: budget,
        };
        adjustedBudgets.push(newFeature);
      });
      const numberToTakeEachTime = 500;
      let startCount = 0;
      let hasMoreRecords = true;
      let finalResults = "";
      while (hasMoreRecords) {
        const numberToTake =
          startCount + numberToTakeEachTime > adjustedBudgets.length
            ? adjustedBudgets.length - startCount
            : numberToTakeEachTime;
        let numbersToRun = adjustedBudgets.slice(
          startCount,
          numberToTake + startCount
        );
        try {
          finalResults = await GeneralService.updateCallForMultiples(
            featureUrl,
            nifcToken,
            numbersToRun
          );
          if (finalResults && finalResults.addResults) {
            allFinalResults.push(finalResults.addResults);
          }
        } catch (e) {
          numbersToRun.forEach((item) => {
            let identifier =
              item[FieldNames.featureFields.objectID] +
              "-" +
              item[FieldNames.budgetFields.constructedFieldName] +
              "-" +
              item[FieldNames.budgetFields.subUnit] +
              "-" +
              item[FieldNames.budgetFields.tribe];
            const newItem = {
              objectId: identifier,
              success: false,
            };
            allFinalResults.push(newItem);
          });
        }
        hasMoreRecords =
          adjustedBudgets.length > startCount + numberToTakeEachTime;
        startCount += numberToTakeEachTime;
      }
      let failedItems = [];
      let successfulItems = [];
      if (!hasMoreRecords) {
        allFinalResults.flat().forEach((result) => {
          if (result) {
            if (!result.success) {
              failedItems.push(result.objectId);
            } else {
              successfulItems.push(result.objectId);
            }
          }
        });
      }

      const allItemResults = {
        successful: successfulItems,
        failures: failedItems,
      };
      return allItemResults;
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  updateMultipleBudgets: async function (
    budgetsForUpdating
  ) {
    try
    {
      let allFinalResults = [];
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();

      let featureUrl = `${rootServiceUrl}/${
        config.budget[config.env].layerId
      }/updateFeatures`;

      let adjustedBudgets = [];
      budgetsForUpdating.forEach((budget) => {
        const newFeature = {
          attributes: budget,
        };
        adjustedBudgets.push(newFeature);
      });
      const numberToTakeEachTime = 500;
      let startCount = 0;
      let hasMoreRecords = true;
      let finalResults = "";
      while (hasMoreRecords) {
        const numberToTake =
          startCount + numberToTakeEachTime > adjustedBudgets.length
            ? adjustedBudgets.length - startCount
            : numberToTakeEachTime;
        let numbersToRun = adjustedBudgets.slice(
          startCount,
          numberToTake + startCount
        );
        try {
          finalResults = await GeneralService.updateCallForMultiples(
            featureUrl,
            nifcToken,
            numbersToRun
          );
          if (finalResults && finalResults.updateResults) {
            allFinalResults.push(finalResults.updateResults);
          }
        } catch (e) {
          numbersToRun.forEach((item) => {
            const newItem = {
              objectId: item.attributes[FieldNames.featureFields.objectID],
              success: false,
            };
            allFinalResults.push(newItem);
          });
        }
        hasMoreRecords =
          adjustedBudgets.length > startCount + numberToTakeEachTime;
        startCount += numberToTakeEachTime;
      }
      let failedItems = [];
      let successfulItems = [];
      if (!hasMoreRecords) {
        allFinalResults.flat().forEach((result) => {
          if (result) {
            if (!result.success) {
              failedItems.push(result.objectId);
            } else {
              successfulItems.push(result.objectId);
            }
          }
        });
      }

      const allItemResults = {
        successful: successfulItems,
        failures: failedItems,
      };
      return allItemResults;
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },

  //
  // Fallback Queries to handle rows not in the budget table
  //

  getBudgetUnits: function (
    department,
    agency,
    region,
    unit,
    subunit,
    tribeFullName
  ) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let baseWhereClause = "";
    baseWhereClause =
      baseWhereClause +
      (department && department[FieldNames.budgetFields.department]
        ? `(Department = '${
            department[FieldNames.budgetFields.department]
          }')`
        : "");
    baseWhereClause =
      baseWhereClause +
      (agency && agency[FieldNames.budgetFields.agency]
        ? ` AND (Agency = '${agency[FieldNames.budgetFields.agency]}')`
        : "");
    baseWhereClause =
      baseWhereClause +
      (region && region[FieldNames.budgetFields.region]
        ? ` AND (Region = '${region[FieldNames.budgetFields.region]}')`
        : "");
    baseWhereClause =
      baseWhereClause +
      (unit && unit[FieldNames.budgetFields.unit]
        ? ` AND (Unit = '${unit[FieldNames.budgetFields.unit]}')`
        : "");

    // Change UnitType to prevent units from setting their own value, only SubUnits/Tribes under them
    if (
      agency &&
      agency[FieldNames.budgetFields.agency] &&
      unit &&
      unit[FieldNames.budgetFields.unit]
    ) {
      if (agency[FieldNames.budgetFields.agency] === FieldNames.agencies.blm) {
        //SubUnit
        baseWhereClause =
          baseWhereClause + ` AND (UnitType = '${FieldNames.unitTypes.subUnit}')`;
      } else if (
        agency[FieldNames.budgetFields.agency] === FieldNames.agencies.bia
      ) {
        //Tribal
        baseWhereClause =
          baseWhereClause + ` AND (UnitType = '${FieldNames.unitTypes.tribal}')`;
        }
      }

      if (
        (subunit && subunit[FieldNames.budgetFields.subUnit]) ||
        (tribeFullName &&
          tribeFullName[FieldNames.budgetFields.constructedTribeFullName])
      ) {
        // No grid values when looking at SubUnit/Tribal level
        return new Promise((resolve) => {
          resolve([]);
        });
      }

    let andCheck = baseWhereClause.substring(0,5) === " AND ";
    let trimedWhereClause = andCheck ? baseWhereClause.substring(5) : baseWhereClause;
    let finalClause = "(" + trimedWhereClause + ")";

      const queryObject = new Query({
        where: finalClause,
        outFields: "*",
        returnDistinctValues: true,
        orderByFields: "OBJECTID",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(
          rootServiceUrl + "/" + config.units[config.env].layerId,
          queryObject
        )
        .then((results) => {
          let items = [];
          if (results && results.features && results.features.length > 0) {
            let initialSet = [];
            initialSet = results.features.map((eaItem) => eaItem.attributes);
            if (initialSet && initialSet.length > 0) {
              items = initialSet.map((item) => {
                let name = item[FieldNames.budgetFields.unit];
                let subunit = item[FieldNames.budgetFields.subUnit];
                let tribe =
                  item[FieldNames.budgetFields.constructedTribeFullName];
                let row = {
                  OBJECTID: null,
                  Name: name,
                  Department: item[FieldNames.budgetFields.department],
                  Agency: item[FieldNames.budgetFields.agency],
                  Region: item[FieldNames.budgetFields.region],
                  Unit: item[FieldNames.budgetFields.unit],
                  SubUnit: subunit,
                  Tribe: tribe,
                  RegularBudget: 0,
                  BILBudget: 0,
                  DisasterReliefBudget: 0,
                  TotalBudget: 0,
                  CreatedBy: null,
                  CreatedOnDate: null,
                  LastModifiedBy: null,
                  LastModifiedDate: null,
                  IsArchived: FieldNames.yesNo.no,
                };

                return row;
              });
            }
          }
          return items;
        });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },

  getBudgetRegionsByAgency: function (
    department,
    agency
  ) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(Agency = '${
          agency[FieldNames.budgetFields.agency]
        }')`,
        outFields: "Region",
        returnDistinctValues: true,
        orderByFields: "Region",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(
          rootServiceUrl + "/" + config.units[config.env].layerId,
          queryObject
        )
        .then((results) => {
          let items = [];
          let initialSet = [];
          if (results && results.features && results.features.length > 0) {
            initialSet = results.features.map((eaItem) => eaItem.attributes);
            if (initialSet && initialSet.length > 0) {
              items = initialSet.map((item) => {
                let name = "";
                let subunit = "";
                let tribe = "";

                name = item[FieldNames.budgetFields.region];
                subunit = "";
                tribe = "";

                let row = {
                  OBJECTID: null,
                  Name: name,
                  Department: department,
                  Agency: agency,
                  Region: item[FieldNames.budgetFields.region],
                  Unit: "",
                  SubUnit: subunit,
                  Tribe: tribe,
                  RegularBudget: 0,
                  BILBudget: 0,
                  DisasterReliefBudget: 0,
                  TotalBudget: 0,
                  CreatedBy: null,
                  CreatedOnDate: null,
                  LastModifiedBy: null,
                  LastModifiedDate: null,
                  IsArchived: FieldNames.yesNo.no,
                };

                return row;
              });
            }
          }
          return items;
        });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },

  getBudgetAgencyByDepartment: function (department) {
    try
    {
      const queryObject = new Query({
        where: `(Department = '${
          department[FieldNames.budgetFields.department]
        }')`,
        outFields: "Agency",
        returnDistinctValues: true,
        orderByFields: "Agency",
        returnGeometry: false,
      });
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      
      return GeneralService.queryCallDirect(
          rootServiceUrl + "/" + config.units[config.env].layerId,
          queryObject
        )
        .then((results) => {
          let items = [];
          let initialSet = [];
          if (results && results.features && results.features.length > 0) {
            initialSet = results.features.map((eaItem) => eaItem.attributes);
            if (initialSet && initialSet.length > 0) {
              items = initialSet.map((item) => {
                let name = "";
                let subunit = "";
                let tribe = "";

                name = item[FieldNames.budgetFields.agency];
                subunit = "";
                tribe = "";

                let row = {
                  OBJECTID: null,
                  Name: name,
                  Department: department,
                  Agency: item[FieldNames.budgetFields.agency],
                  Region: "",
                  Unit: "",
                  SubUnit: subunit,
                  Tribe: tribe,
                  RegularBudget: 0,
                  BILBudget: 0,
                  DisasterReliefBudget: 0,
                  TotalBudget: 0,
                  CreatedBy: null,
                  CreatedOnDate: null,
                  LastModifiedBy: null,
                  LastModifiedDate: null,
                  IsArchived: FieldNames.yesNo.no,
                };

                return row;
              });
            }
          }
          return items;
        });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },

  getBudgetDepartments: function () {
    try
    {
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "Department",
        returnDistinctValues: true,
        orderByFields: "Department",
        returnGeometry: false,
      });
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      return query.executeQueryJSON(
          rootServiceUrl + "/" + config.units[config.env].layerId,
          queryObject
        )
        .then((results) => {
          let items = [];
          let initialSet = [];
          if (results && results.features && results.features.length > 0) {
            initialSet = results.features.map((eaItem) => eaItem.attributes);
            if (initialSet && initialSet.length > 0) {
              items = initialSet.map((item) => {
                let name = "";
                let subunit = "";
                let tribe = "";

                name = item[FieldNames.budgetFields.department];
                subunit = "";
                tribe = "";

                let row = {
                  OBJECTID: null,
                  Name: name,
                  Department: item[FieldNames.budgetFields.department],
                  Agency: "",
                  Region: "",
                  Unit: "",
                  SubUnit: subunit,
                  Tribe: tribe,
                  RegularBudget: 0,
                  BILBudget: 0,
                  DisasterReliefBudget: 0,
                  TotalBudget: 0,
                  CreatedBy: null,
                  CreatedOnDate: null,
                  LastModifiedBy: null,
                  LastModifiedDate: null,
                  IsArchived: FieldNames.yesNo.no,
                };

                return row;
              });
            }
          }
          return items;
        });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
};

export default BudgetService;
